enum AccountProviderType {
  INTERNAL = 'Internal',
  EXTERNAL = 'External',
}

export default AccountProviderType;
